import { createAction } from 'redux-actions';
import uuid from 'uuid/v4';
import {
  createParams,
  validateParams,
  getValueFromObjects,
  getAddressMappingV2,
  getCustomerAge,
  getCPRMapping,
  prepareCommonCreateUpdateResponse,
} from './common';
import Product from './product';
import * as types from '../../constants/Api';
import { appErrorAction } from '../../actions/App';
import { createErrorBody } from '../error';
import { getBasePackages } from '../package/packageUtils';
import {
  userDataChangeAction,
} from '../../actions/UserData';

class HouseholdService extends Product {
  static TYPE = 'household';

  static GET_PRICE = 'householdcontents/v1/price';
  static GET_BBR_INFO = 'householdcontents/v1/bbrinfo';
  static UPDATE_PRICE = 'householdcontents/v1/price';
  static GET_PRICE_AUX_SERVICE = 'product/v1/auxiliaryprice/indbo';
  static CREATE_CUSTOMER = 'product/v1/customer';
  static HOUSEHOLD_PURCHASE = 'householdcontents/v1/purchase';

  static updatedHouseCoverageState = createAction(
    types.HOUSEHOLD_COV_STATE_UPDATED
  );

  static createdHousehold = createAction(types.HOUSEHOLD_CREATED);
  static createHousehold = createAction(types.HOUSEHOLD_CREATE);
  static updatedHousehold = createAction(types.HOUSEHOLD_UPDATED);
  static updateHousehold = createAction(types.HOUSEHOLD_UPDATE);
  static preparedHousehold = createAction(types.HOUSEHOLD_PREPARED);
  static prepareHousehold = createAction(types.HOUSEHOLD_PREPARE);
  static updatedPriceAuxiliary = createAction(types.HOUSEHOLD_AUX_UPDATED);
  static reciveAddressHousehold = createAction(types.HOUSEHOLD_ADDRESS_RECEIVE);
  static recivedAddressHousehold = createAction(types.HOUSEHOLD_ADDRESS_RECEIVED);
  static reciveAddressErrorHousehold = createAction(types.HOUSEHOLD_ADDRESS_RECEIVE_ERROR);
  static recivedAddressErrorHousehold = createAction(types.HOUSEHOLD_ADDRESS_RECEIVED_ERROR);

  constructor() {
    super(
      HouseholdService.TYPE,
      HouseholdService.createHousehold,
      HouseholdService.updateHousehold,
      HouseholdService.prepareHousehold,
      HouseholdService.reciveAddressHousehold,
      HouseholdService.reciveAddressErrorHousehold
    );
    super.prepareCreateUpdateResponse = this.prepareCreateUpdateResponse;
  }

  createdHouseholdAction(payload) {
    return (dispatch) => dispatch(HouseholdService.createdHousehold(payload));
  }

  reciveAddressErrorHouseholdAction() {
    return (dispatch) =>
      dispatch(HouseholdService.reciveAddressErrorHousehold());
  }

  recivedAddressErrorHouseholdAction(payload) {
    return (dispatch) => dispatch(HouseholdService.recivedAddressErrorHousehold(payload));
  }

  reciveAddressHouseholdAction() {
    return (dispatch) =>
      dispatch(HouseholdService.reciveAddressHousehold());
  }

  recivedAddressHouseholdAction(payload) {
    return (dispatch) => dispatch(HouseholdService.recivedAddressHousehold(payload));
  }

  createHouseholdAction(mappedParams, actionOnErrors, reqModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateBaseModelProduct(
          HouseholdService.GET_PRICE,
          mappedParams,
          reqModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.createdHouseholdAction(data));
          dispatch(this.updateHouseCoverageStateAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  updatedHouseholdAction(payload) {
    return (dispatch) => dispatch(HouseholdService.updatedHousehold(payload));
  }

  updateHouseholdAction(mappedParams, actionOnErrors, reqModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateBaseModelProduct(
          HouseholdService.UPDATE_PRICE,
          mappedParams,
          reqModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.updatedHouseholdAction(data));
          dispatch(this.updateHouseCoverageStateAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  updatedHouseCoverageStateAction(payload) {
    return (dispatch) => dispatch(HouseholdService.updatedHouseCoverageState(payload));
  }

  updateHouseCoverageStateAction(payload) {
    return (dispatch) => {
      const houseCov = this.selectHouseCov(payload);
      dispatch(this.updatedHouseCoverageStateAction(houseCov));
    };
  }

  selectHouseCov(payload) {
    let houseCov = { houseCov: 'false' };
    Object.keys(payload).forEach(key => {
      if (payload[key].selectedCoverage.includes('NBOD')) {
        houseCov = { houseCov: 'true' };
      }
    });
    return houseCov;
  }

  createUpdateHouseholdAction(params, actionOnErrors, values) {
    return (dispatch, getState) => {
      const { formValues, mappedParams } = this.mapUserdata(getState(), values, params);
      const requestModel = this.getRequestModel(mappedParams, formValues);
      requestModel.customer = {
        age: getCustomerAge(mappedParams, formValues),
        birthdate: getValueFromObjects('birthdate', mappedParams, formValues),
        civilRegistrationNumber: getCPRMapping(mappedParams, formValues),
        totalInsured: getValueFromObjects('totalInsured', mappedParams, formValues),
        totalInsuredChildren: getValueFromObjects('totalInsuredChildren', mappedParams, formValues),
        contentsInsuranceRecentYear: true,
        claimCount: getValueFromObjects('claimCount', mappedParams, formValues),
        isInRKI: false,
        rolePlayerId: getValueFromObjects('rolePlayerId', mappedParams, formValues),
        postalAddress: getAddressMappingV2(mappedParams, formValues),
      };
      requestModel.house = {
        housingType: getValueFromObjects('housingType', mappedParams, formValues),
        ownershipType: getValueFromObjects('ownerShip', mappedParams, formValues),
        occupiedArea: getValueFromObjects('occupiedArea', mappedParams, formValues),
        basementArea: getValueFromObjects('basementArea', mappedParams, formValues),
        roofType: getValueFromObjects('roofType', mappedParams, formValues),
      };
      requestModel.deductible = getValueFromObjects('deductible-household', mappedParams, formValues);
      requestModel.packageText = getValueFromObjects('packageText', mappedParams, formValues);
      requestModel.coverage = [];
      requestModel.sumInsured = {
        bicycleSum: getValueFromObjects('bicyclesum-household', mappedParams, formValues),
        luggageSum: getValueFromObjects('luggageSum', mappedParams, formValues),
        basementSum: getValueFromObjects('basementSum', mappedParams, formValues),
        standardSumSeparateThings: getValueFromObjects('standardSumSeparateThings-household', mappedParams, formValues),
        designerFurnitureSum: getValueFromObjects('designerFurnitureSum', mappedParams, formValues),
        jewellerySum: getValueFromObjects('jewellerySum', mappedParams, formValues),
        coinAndStampCollectionSum: getValueFromObjects('coinAndStampCollectionSum', mappedParams, formValues),
      };

      if (getState().userData.household) {
        return dispatch(
          this.updateHouseholdAction(mappedParams, actionOnErrors, requestModel, {
            ...formValues,
          })
        ).catch(data => {
          return Promise.resolve(data);
        });
      }

      return dispatch(
        this.createHouseholdAction(mappedParams, actionOnErrors, requestModel, formValues)
      ).catch(data => {
        return Promise.resolve(data);
      });
    };
  }

  selectedCoverageMapping(coverage) {
    const result = [];
    coverage.map((option) => {
      result.push(option.coverageCode);
      return null;
    });
    return result;
  }

  calculatePriceAndFee(price, feeList, formValues) {
    const guaranteeFee =
      Math.round(this.getFeeAmountPerPayment(feeList, 'GARB') * 100) / 100;
    const floodFee =
      Math.round(this.getFeeAmountPerPayment(feeList, 'STFL') * 100) / 100;

    const priceWithFee = Math.round(price.premiumAmount * 100) / 100;

    return {
      premiumPrice: price.premiumWithOutFee,
      floodFee: `${floodFee}`,
      guaranteeFee: `${guaranteeFee}`,
      priceWithFee: `${priceWithFee}`,
      insuranceFee: price.insuranceToll,
      paymentFee: formValues.paymentFee || '',
    };
  }

  prepareCreateUpdateResponse(payload, mappedParams, formValues) {
    let response = prepareCommonCreateUpdateResponse.call(this, payload, formValues);
    const coverageCodes = this.selectedCoverageMapping(payload.selectedCoverage);
    if (payload.advantageText === 'Cykel el. alarm') {
      coverageCodes.push('NALM');
    }
    if (payload.advantageText === 'Cykel og alarm') {
      coverageCodes.push('NCYF');
    }
    response = {
      ...response,
      usedParams: { coverageCodes },
      selectedCoverage: coverageCodes,
      sumInsured: {
        bicycleSum: payload.sumInsured.bicycleSum,
        luggageSum: payload.sumInsured.luggageSum,
        basementSum: payload.sumInsured.basementSum,
        standardSumSeparateThings: payload.sumInsured.standardSumSeparateThings,
        designerFurnitureSum: payload.sumInsured.designerFurnitureSum === ''
          ? '60.000' : payload.sumInsured.designerFurnitureSum,
        jewellerySum: payload.sumInsured.jewellerySum === ''
          ? '60.000' : payload.sumInsured.jewellerySum,
        coinAndStampCollectionSum: payload.sumInsured.coinAndStampCollectionSum === ''
          ? '60.000' : payload.sumInsured.coinAndStampCollectionSum,
      },
      KVHX: payload.customer.postalAddress.KVHX,
      priceApiResponse: [
        {
          offeredPrice: this.calculatePriceAndFee(
            payload.price.offeredPrice,
            payload.price.fees,
            formValues
          ),
          listPrice: this.calculatePriceAndFee(
            payload.price.listPrice,
            payload.price.fees,
            formValues
          ),
          advantagePrice: this.calculatePriceAndFee(
            payload.price.advantagePrice,
            payload.price.fees,
            formValues
          ),
          discountAmount:
            this.calculatePriceAndFee(
              payload.price.listPrice,
              payload.price.fees,
              formValues
            ).priceWithFee -
            this.calculatePriceAndFee(
              payload.price.offeredPrice,
              payload.price.fees,
              formValues
            ).priceWithFee,
        },
      ],
    };
    return response;
  }

  getHouseholdMapping() {
    return {
      product: {
        type: HouseholdService.TYPE,
      },
    };
  }

  returnedPriceAuxAction(payload) {
    return (dispatch) => dispatch(HouseholdService.updatedPriceAuxiliary(payload));
  }
  returnPriceAuxAction() {
    return (dispatch) => {
      return dispatch(
        this.getPriceAuxiliaryService(dispatch)
      )
        .then((data) => {
          dispatch(this.returnedPriceAuxAction(data));
        })
        .catch((data) => {
          dispatch(appErrorAction(data));
          return Promise.reject(data);
        });
    };
  }

  /**
   * This method will used to load all aux services for Household
   * @param dispatch
   */
  getPriceAuxiliaryService() {
    return (dispatch) => {
      return this.callApiGet(
        HouseholdService.GET_PRICE_AUX_SERVICE,
        null,
        dispatch
      ).then((response) => {
        return this.getAuxServiceMapping(response.auxiliaryList);
      });
    };
  }

  getAuxServiceMapping(auxiliaryList) {
    const auxResult = {};
    const auxlist = auxiliaryList;
    auxlist.map((auxlistitem) => {
      const options = [];
      auxlistitem.auxListValues.map((option) => {
        options.push({ 'key': option, 'value': option });
        return option;
      });
      const name = `aux${auxlistitem.auxListName}`;
      auxResult[name] = options;
      return auxResult;
    });
    return auxResult;
  }

  /* household bbrinfo call starts for validation here */
  returnHouseholdAddressDetailsAction(params, values) {
    return (dispatch, getState) => {
      const { formValues, mappedParams } = this.mapUserdata(getState(), values, params);
      const requestModel = this.getHouseHoldAddressRequestModel(mappedParams, formValues);
      requestModel.postalAddress = getAddressMappingV2(mappedParams, formValues);
      requestModel.house = {
        ownershipType: getValueFromObjects('ownerShip', mappedParams, formValues),
      };
      this.reciveAddressHouseholdAction();
      return this.callApiPost(HouseholdService.GET_BBR_INFO, requestModel, dispatch)
        .then((data) => {
          if (data.house.housingType && data.house.basementArea && data.house.roofType &&
            data.house.occupiedArea) {
            dispatch(this.recivedAddressHouseholdAction(data));
          } else {
            const errorDetails = {
              response: {
                data: {
                  errorDetails: {
                    filedErrorCode: 'F500',
                    proposedHttpError: 403,
                    housingType: data.house.housingType,
                    basementArea: data.house.basementArea,
                    roofType: data.house.roofType,
                    occupiedArea: data.house.occupiedArea,
                  },
                },
              },
            };
            return Promise.reject(errorDetails);
          }
          dispatch(userDataChangeAction({
            fields: [{
              field: "bbrSuccess",
              value: true,
            }]
          }));
          return data;
        })
        .catch(error => {
          if (error.response.data.errorDetails.errorCode === 'F99999') {
            const errorDetailsfinal = {
              response: {
                data: {
                  errorDetails: {
                    errorCode: error.response.data.errorDetails.errorCode,
                    proposedHttpError: 403,
                    housingType: '',
                    basementArea: '',
                    roofType: '',
                    occupiedArea: '',
                  },
                },
              },
            };
            dispatch(this.recivedAddressErrorHouseholdAction(
              errorDetailsfinal.response.data.errorDetails));
          } else if (error.response.data.errorDetails.filedErrorCode === 'F500') {
            const errorFieldDetails = {
              response: {
                data: {
                  errorDetails: {
                    errorCode: error.response.data.errorDetails.filedErrorCode,
                    proposedHttpError: 403,
                    housingType: error.response.data.errorDetails.housingType,
                    basementArea: error.response.data.errorDetails.basementArea,
                    roofType: error.response.data.errorDetails.roofType,
                    occupiedArea: error.response.data.errorDetails.occupiedArea,
                  },
                },
              },
            };
            dispatch(this.recivedAddressErrorHouseholdAction(
              errorFieldDetails.response.data.errorDetails));
          } else {
            dispatch(
              this.recivedAddressErrorHouseholdAction(error.response.data.errorDetails));
          }
          dispatch(userDataChangeAction({
            fields: [{
              field: "bbrSuccess",
              value: false,
            }]
          }));
          return Promise.reject(error);
        });
    };
  }
  /* household bbrinfo call ends validation  */

  requestCreateBaseModelProduct(service, mappedParams, baseReqModel, formValues) {
    return (dispatch, getState) => {
      const state = getState();
      if (this.shouldUpdate(state)) {
        let packageInfo = getBasePackages(state, mappedParams);

        dispatch(this.createAction());
        dispatch(this.quoteCustomerAction());

        if (packageInfo.length > 0) {
          const { userData: { packageId } } = state;
          if (packageId) {
            packageInfo = packageInfo.filter(item => item.packageId === packageId);
          }

          const requests = [];

          packageInfo.forEach(item => {
            const additionalPackageInfo = formValues.additionalPackagesInfo && formValues.additionalPackagesInfo.find(({ id }) => id === item.packageId);
            if (!formValues.forProduct || formValues.forProduct === additionalPackageInfo?.forProduct) {
              let packageRequest = baseReqModel;
              let studentCoverage = [];
              if (this.isStudentWidget(mappedParams, formValues)) {
                studentCoverage = item.coverageCodes.map((cov) => {
                  return { coverageCode: cov };
                });
              }
              const coverage = studentCoverage;
              if (formValues[this.type] && formValues[this.type][item.packageId]) {
                const updateReq = {
                  general: {
                    ...packageRequest.general,
                    globalTransactionId: uuid(),
                  },
                  generalInsurance: {
                    ...packageRequest.generalInsurance,
                    sessionKey: formValues[this.type][item.packageId].sessionKey || '',
                  },
                };
                packageRequest = { ...packageRequest, ...updateReq };
              } else {
                const updateReq = {
                  general: {
                    ...packageRequest.general,
                    globalTransactionId: uuid(),
                  },
                };
                packageRequest = { ...packageRequest, ...updateReq };
              }
              requests.push({
                ...packageRequest,
                packageText: item.packageText,
                packageId: item.packageId,
                coverage,
              });
            }
          });

          return this.callGetPriceRequests(service, requests
            , mappedParams, formValues, dispatch);
        }

        return dispatch(this.createProduct(service, ...baseReqModel,
          mappedParams, formValues))
          .then(data => {
            dispatch(this.quotedCustomerAction(data));
          });
      }

      return Promise.resolve();
    };
  }

  purchase(params, values, actionOnErrors) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params ? createParams(params, formValues, state) : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }

      const requestModel = {};

      return dispatch(super.purchaseV2(HouseholdService.HOUSEHOLD_PURCHASE,
        mappedParams, requestModel, formValues, actionOnErrors));
    };
  }

  isStudentWidget(mappedParams, formValues) {
    const studentWidget =
      getValueFromObjects(
        'studentWidget',
        mappedParams,
        formValues
      ) || 'N';
    return studentWidget === 'Y';
  }
}

export const householdService = new HouseholdService();
